/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OtherQaEquipmentDto } from './OtherQaEquipmentDto';
import {
    instanceOfOtherQaEquipmentDto,
    OtherQaEquipmentDtoFromJSON,
    OtherQaEquipmentDtoFromJSONTyped,
    OtherQaEquipmentDtoToJSON,
} from './OtherQaEquipmentDto';
import type { PtwQaEquipmentWithRegistrationDto } from './PtwQaEquipmentWithRegistrationDto';
import {
    instanceOfPtwQaEquipmentWithRegistrationDto,
    PtwQaEquipmentWithRegistrationDtoFromJSON,
    PtwQaEquipmentWithRegistrationDtoFromJSONTyped,
    PtwQaEquipmentWithRegistrationDtoToJSON,
} from './PtwQaEquipmentWithRegistrationDto';
import type { PtwQaEquipmentWithSerialNumberDto } from './PtwQaEquipmentWithSerialNumberDto';
import {
    instanceOfPtwQaEquipmentWithSerialNumberDto,
    PtwQaEquipmentWithSerialNumberDtoFromJSON,
    PtwQaEquipmentWithSerialNumberDtoFromJSONTyped,
    PtwQaEquipmentWithSerialNumberDtoToJSON,
} from './PtwQaEquipmentWithSerialNumberDto';
import type { PtwQaEquipmentWithoutSerialNumberDto } from './PtwQaEquipmentWithoutSerialNumberDto';
import {
    instanceOfPtwQaEquipmentWithoutSerialNumberDto,
    PtwQaEquipmentWithoutSerialNumberDtoFromJSON,
    PtwQaEquipmentWithoutSerialNumberDtoFromJSONTyped,
    PtwQaEquipmentWithoutSerialNumberDtoToJSON,
} from './PtwQaEquipmentWithoutSerialNumberDto';
import type { UnicheckDeviceDto } from './UnicheckDeviceDto';
import {
    instanceOfUnicheckDeviceDto,
    UnicheckDeviceDtoFromJSON,
    UnicheckDeviceDtoFromJSONTyped,
    UnicheckDeviceDtoToJSON,
} from './UnicheckDeviceDto';
import type { UnicheckSimulatorDto } from './UnicheckSimulatorDto';
import {
    instanceOfUnicheckSimulatorDto,
    UnicheckSimulatorDtoFromJSON,
    UnicheckSimulatorDtoFromJSONTyped,
    UnicheckSimulatorDtoToJSON,
} from './UnicheckSimulatorDto';

/**
 * @type QaEquipmentRtSystemDto
 * 
 * @export
 */
export type QaEquipmentRtSystemDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.OtherQaEquipmentDto, Ptw.Ptw100.AppZero.Application.Shared' } & OtherQaEquipmentDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithRegistrationDto, Ptw.Ptw100.AppZero.Application.Shared' } & PtwQaEquipmentWithRegistrationDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared' } & PtwQaEquipmentWithSerialNumberDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithoutSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared' } & PtwQaEquipmentWithoutSerialNumberDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.UnicheckDeviceDto, Ptw.Ptw100.AppZero.Application.Shared' } & UnicheckDeviceDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.UnicheckSimulatorDto, Ptw.Ptw100.AppZero.Application.Shared' } & UnicheckSimulatorDto;


export function QaEquipmentRtSystemDtoFromJSON(json: any): QaEquipmentRtSystemDto {
    return QaEquipmentRtSystemDtoFromJSONTyped(json, false);
}

export function QaEquipmentRtSystemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QaEquipmentRtSystemDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.OtherQaEquipmentDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, OtherQaEquipmentDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.OtherQaEquipmentDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithRegistrationDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, PtwQaEquipmentWithRegistrationDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithRegistrationDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, PtwQaEquipmentWithSerialNumberDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithoutSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, PtwQaEquipmentWithoutSerialNumberDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithoutSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.UnicheckDeviceDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, UnicheckDeviceDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.UnicheckDeviceDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.UnicheckSimulatorDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, UnicheckSimulatorDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.UnicheckSimulatorDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of QaEquipmentRtSystemDto exists with '$type=${json['$type']}'`);
    }
}

export function QaEquipmentRtSystemDtoToJSON(value?: QaEquipmentRtSystemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.OtherQaEquipmentDto, Ptw.Ptw100.AppZero.Application.Shared':
            return OtherQaEquipmentDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithRegistrationDto, Ptw.Ptw100.AppZero.Application.Shared':
            return PtwQaEquipmentWithRegistrationDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared':
            return PtwQaEquipmentWithSerialNumberDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithoutSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared':
            return PtwQaEquipmentWithoutSerialNumberDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.UnicheckDeviceDto, Ptw.Ptw100.AppZero.Application.Shared':
            return UnicheckDeviceDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.UnicheckSimulatorDto, Ptw.Ptw100.AppZero.Application.Shared':
            return UnicheckSimulatorDtoToJSON(value);
        default:
            throw new Error(`No variant of QaEquipmentRtSystemDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the QaEquipmentRtSystemDto interface.
 */
export function instanceOfQaEquipmentRtSystemDto(value: any): value is QaEquipmentRtSystemDto {
    if (instanceOfOtherQaEquipmentDto(value)) return true;
    if (instanceOfPtwQaEquipmentWithRegistrationDto(value)) return true;
    if (instanceOfPtwQaEquipmentWithSerialNumberDto(value)) return true;
    if (instanceOfPtwQaEquipmentWithoutSerialNumberDto(value)) return true;
    if (instanceOfUnicheckDeviceDto(value)) return true;
    if (instanceOfUnicheckSimulatorDto(value)) return true;
    return false;
}

